<template>
  <div class="d-flex justify-content-center align-items-center text-uppercase text-muted my-3 py-3 border-top border-bottom">
    Salto de página
  </div>
</template>

<script>
import lmInputMixin from '@/mixins/lmInputMixin.js'
import { defineComponent } from 'vue'

export default defineComponent({
  mixins: [lmInputMixin]
})
</script>
